import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import "./styles/Verification.css";
import { HalfBox } from "../components/scripts/HalfBox";
import { ApiCall } from "../utility/ApiCalls";
import Loader from "react-loader-spinner";
import { string } from "postcss-selector-parser";
import Api_Call from "../ApiCall";
import UserContext from "../components/Common/UserContext";
import menus from "../user-config.json";
import ErrorPage from "../components/Common/ErrorPage";

function Verification() {
  const [isLoading, setLoading] = useState(true);
  const [ocrData, setOCRData] = useState([]);
  const [displayReady, setDisplayReady] = useState(false);
  const [displayReadyActiveTask, setDisplayReadyActiveTask] = useState(false);
  const [displayReadyFax, setDisplayReadyFax] = useState(false);
  const [activeTaskData, setActiveTaskData] = useState([]);
  const [ocrDataCPT, setCPTData] = useState([]);
  const [ocrDataDX, setDXData] = useState([]);
  const [ocrDataProvider, setProviderData] = useState([]);
  const [umreviewType, setUMReviewType] = useState([]);
  const [admissionSource, setAdmissionSource] = useState([]);
  const [admissionType, setAdmissionType] = useState([]);
  const [requestProfile, setRequestProfile] = useState([]);
  const [selectedUMreviewType, setUMReviewTypeSelected] = useState("");
  const [selectedAdmissionSource, setAdmissionSourceSelected] = useState("");
  const [selectedAdmissionType, setAdmissionTypeSelected] = useState("");
  const [selectedRequestProfile, setSelectedRequestProfile] = useState("");
  const [selectedUMReviewTypeData, setSelectedUMReviewTypeData] = useState("");
  const [requestProfileData, setRequestProfileData] = useState("");
  const [coords, setCoords] = useState("");
  const [taskStatus, setTaskStatus] = useState();
  const [completedTime, setCompletedTime] = useState();
  const [Confidence, setConfidence] = useState();
  const [authId, setAuthId] = useState();

  const [fax, setFax] = useState();
  const { userRole } = useContext(UserContext);
  const [error, setError] = useState();

  // API CALL FUNCTION DECLARATION  ============================================================

  async function getvalidatedtask(e) {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&clinical_data=${menus[userRole.toLowerCase()]["clinical"]}`
      );
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      setTaskStatus(data.body.Status);
      setCompletedTime(data.body.Status);
    } catch (error) {
      console.error(error.message);
      setError(error);
    }
  }

  async function getOCRDatafromAPI() {
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&clinical_data=${menus[userRole.toLowerCase()]["clinical"]}`
      );

      if (data.statusCode !== 200) {
        throw new Error("Error Fetching Data");
      }
      const response = data.body;
      console.log(response);

      if (response.CPTCodes != null) {
        setCPTData(response.CPTCodes.value);
      }
      if (response.DiagnosisCodes != null) {
        setDXData(response.DiagnosisCodes.value);
      }
      if (response.Providers != null) {
        setProviderData(response.Providers);
      }
      setOCRData(response);

      setSelectedUMReviewTypeData(response.UMReviewType);
      setRequestProfileData(response.RequestProfile);
      setAuthId(response.Auth_ID);
      return true;
    } catch (error) {
      console.error(error.message);
      setError(error);
    }
  }

  async function getActiveTaskfromAPI() {
    //   try{
    //     const api=new Api_Call();
    //     const data=await api.getData("TASK-LIST?status=1&module=intake")

    //     const response = data.body;
    // setActiveTaskData(response);
    //     if (retActive.statusCode == "200") {
    setDisplayReadyActiveTask(true);
    //     }
    //   }catch(error)
    //   {
    //     console.error(error.message);
    //   }
  }

  async function getUMReviewTypefromAPI() {
    const api = new Api_Call();
    const data = await api.getData(
      "MASTERS/MANAGEMENT?master_type=umreviewtype"
    );
    const response = data.body;
    setUMReviewType(response);

    const api2 = new Api_Call();
    const data2 = await api2.getData(
      "MASTERS/MANAGEMENT?master_type=admissionsource"
    );
    setAdmissionSource(data2.body);

    const api3 = new Api_Call();
    const data3 = await api3.getData(
      "MASTERS/MANAGEMENT?master_type=admissiontype"
    );
    setAdmissionType(data3.body);

    const api4 = new Api_Call();
    const data4 = await api4.getData(
      "MASTERS/MANAGEMENT?master_type=authorizationprofile"
    );
    setRequestProfile(data4.body);
  }

  async function getFaxfromAPI() {
    console.log("=========inside fax api===============");
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `FAX/GET?taskID=${sessionStorage.getItem("ActiveTaskID")}`
      );
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }
      console.log(data);
      setFax(data);
      if (data != undefined) {
        setDisplayReadyFax(true);
      }
    } catch (error) {
      console.error(error.message);
      setError(error);
    }
  }

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  function LoadContent() {
    if (ocrData.length != 0) {
      setDisplayReady(true);
    }
  }

  useEffect(() => {
    getvalidatedtask();
    getOCRDatafromAPI();
    getActiveTaskfromAPI();
    getUMReviewTypefromAPI();
    getFaxfromAPI();
  }, []);

  useEffect(() => {
    LoadContent();
  }, [ocrData]);

  useEffect(() => {
    if (displayReady && displayReadyActiveTask && displayReadyFax) {
      setLoading(false);
    }
  }, [displayReady, displayReadyActiveTask, displayReadyFax]);

  function handleBodyClick(e) {
    //e.preventDefault();
    var activeElement = document.activeElement;
    console.log(document.activeElement);
    var inputs = [
      "txtMemberID_CR",
      "txtDateOfBirth_DT",
      "txtFirstName_CR",
      "txtLastName_CR",
      "txtRequestorName_CR",
      "txtRequestorContactNo_CR",
      "txtRequestorFaxNo_CR",
      "txtServiceRequestDate_DT",
      "txtAnticipatedStart",
      "txttxtAnticipatedEnd",
    ];

    if (activeElement && inputs.indexOf(activeElement.id) !== -1) {
      return;
    }

    var result = document.getElementById("myresult");
    var lens = document.getElementById("highlightbox");
    result.style.display = "none";
    lens.style.display = "none";
    return;

    //     console.log('Getting there !!');
    //     console.log(document.activeElement);
    //     // setresultBoxVisibility("");
    //     var result = document.getElementById("myresult");
    //     var lens = document.getElementById("highlightbox");
    //     result.style.display = "";
    //     lens.style.display = "";
    // }
    // else {
    //     console.log(' Naaaaaahhhhh !!');
    //     console.log(document.activeElement);
    //     // setresultBoxVisibility("none");
    //     var result = document.getElementById("myresult");
    //     var lens = document.getElementById("highlightbox");
    //     result.style.display = "none";
    //     lens.style.display = "none";
    // }
  }
  if (error) {
    return <ErrorPage message={error.message} code={error.code} />;
  }

  if (isLoading) {
    return (
      <div>
        {/* <div className="content-container">
          <div className="div-loading">
            <Loader type="Puff" color="#00BFFF" height={100} width={100} />
          </div>
        </div> */}
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return (
      <>
        <Box className="primary-title-new">
          <img src="img/heading-bg.png" />
          <Typography variant="h1">
            Utilization Management - <span> Intake Verification</span>
          </Typography>
        </Box>
        <div className="verification-content-main">
          <div className="content-container halfbox-container">
            <HalfBox
              fax={fax}
              coords={coords}
              ocrData={ocrData}
              taskData={activeTaskData}
              setOCRData={setOCRData}
              selectedUMReviewTypeData={selectedUMReviewTypeData}
              requestProfileData={requestProfileData}
              dxData={ocrDataDX}
              setDXData={setDXData}
              cptData={ocrDataCPT}
              setCPTData={setCPTData}
              providerData={ocrDataProvider}
              setProviderData={setProviderData}
              umReviewTypeCB={umreviewType}
              admissionSourceCB={admissionSource}
              requestProfileCB={requestProfile}
              admissionTypeCB={admissionType}
              selectedUMreviewType={selectedUMreviewType}
              setUMReviewTypeSelected={setUMReviewTypeSelected}
              selectedAdmissionSource={selectedAdmissionSource}
              setAdmissionSourceSelected={setAdmissionSourceSelected}
              selectedAdmissionType={selectedAdmissionType}
              setAdmissionTypeSelected={setAdmissionTypeSelected}
              selectedRequestProfile={selectedRequestProfile}
              setSelectedRequestProfile={setSelectedRequestProfile}
              loading={isLoading}
              setLoading={setLoading}
              taskStatus={taskStatus}
              completedTime={completedTime}
              getOCRDatafromAPI={getOCRDatafromAPI}
              authId={authId}
            ></HalfBox>
          </div>
        </div>
      </>
    );
  }
}

export default Verification;
